
<app-header></app-header>

<div class="container">
  <form [formGroup]="storyForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="form-group col-sm-12 mt-3 mb-3 text-end">
        <button *ngIf="!isReadOnly" type="submit" class="btn btn-primary">Save</button>
        <!-- <button type="button" class="btn btn-light" (click)="router.navigate(['/create'])">Back</button> -->
      </div>

      <div class="form-group mb-4 col-sm-12">
        <input formControlName="story_title" placeholder="Enter story title" class="form-control" [readonly]="isReadOnly">
      </div>
    </div>
  </form>
</div>

